<!--
 * @Descripttion: 
 * @version: v1.0
 * @Author: wangxiaoyun
 * @Date: 2024-04-28 14:08:31
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-08-30 13:09:34
-->
<template>
  <div class="iframeCenter" @click.self="$store.commit('changechatShow', false)">
    <div class="center">
      <div class="top">
        <i class="el-icon-close" @click="$store.commit('changechatShow', false)"></i>
      </div>
      <iframe :src="src" frameborder="no" style="width: 100%; height: 100%" scrolling="auto" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      token: sessionStorage.getItem("token"),
      pid: this.$store.state.pid,
      src: "",
    };
  },
  mounted() {
    this.pid = this.$store.state.pid;
    console.log(this.pid); 
    this.src = `${this.$store.state.axiosUrl}/manager/uchat.html?tk=${this.token}&pId=${this.pid}`;
    console.log(this.src);
  },
};
</script>
<style lang="less" scoped>
.iframeCenter {
  height: 100%;
  width: 100%;
  position: fixed;
  padding: 1em 3em;
  top: 0;
  left: 0;
  z-index: 111;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  .center {
    // background-color: rgba(#24a0ee, 0.2);
    padding: 10px;
    border-radius: 10px;
    flex: 1;
    .top{
      display: flex;
      justify-content: flex-end;
      background-color: #fff;
    }
    i{
      color: #666;
      font-size: 0.5em;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/consultation.vue